<div class="panel">
  <div class="border-b border-gray-200">
    <div class="px-8 h-20 items-center flex gap-3">
      <!-- The list heading is the button that opens its menu (TW-PANEL-07): named by its text, Enter and Space native. -->
      <button
        type="button"
        class="bg-transparent border-0 p-0 [font:inherit] text-inherit text-left cursor-pointer"
        appDPFilesContextMenu
        (appDPContextMenuOpened)="contextMenuOpened = $event"
        (appDPContextMenuFilterChanged)="selectFilter($event)"
        aria-haspopup="menu"
        [attr.aria-expanded]="!!contextMenuOpened"
      >
        <app-dropdown-label [collapsed]="!contextMenuOpened">
          {{ selectedFilter | titleByFilesFilter }}
        </app-dropdown-label>
      </button>

      <div class="grow"></div>

      @if (selectedTab !== 'folders') {
        <app-context-menu-state-indicator
          svgIcon="filters"
          appFilesListContextMenu
          [appFilesListContextMenuWithAdvancedSearch]="true"
        />
      }
      @if (selectedTab === 'folders') {
        <app-context-menu-state-indicator
          svgIcon="filters"
          appFoldersListContextMenu
          [appFoldersListContextMenuWithAdvancedSearch]="true"
        />
      }

      <app-search-state-indicator [applied]="isSearchApplied()" (clear)="clearSearch()">
        <app-icon
          class="max-w-8 max-h-8 text-gray-500 cursor-pointer items-center"
          name="search-small"
          stchPopover
          stchPopoverPlacement="bottomRight"
          stchPopoverTrigger="click"
          [stchPopoverContent]="searchPopover"
          [stchPopoverFallbackPlacements]="[]"
          [stchPopoverShowUntil]="popoverClose"
        />
      </app-search-state-indicator>
    </div>
    @if (listState === 'tabs') {
      <app-tabs class="panel-heading-tabs" [values]="tabs" [(value)]="selectedTab" />
    }
  </div>

  @if (selectedTab === 'files' && creationAllowed()) {
    <app-quick-form class="panel-quick-form" trigger="button" [collapseKey]="selectedFilter" placeholder="Add New File">
      <app-file-quick-form [showMore]="true" (more)="handleNewFile($event)" />
    </app-quick-form>
  }

  @if (selectedTab === 'folders' && creationAllowed()) {
    <app-quick-form
      class="panel-quick-form"
      trigger="button"
      [collapseKey]="selectedFilter"
      placeholder="Add New Folder"
    >
      <app-folder-quick-form [showMore]="true" (more)="handleNewFolder($event)" />
    </app-quick-form>
  }

  <div class="panel-list border-t border-gray-200">
    @if (selectedTab !== 'folders' && filesFilters) {
      <app-files-list
        [filters]="filesFilters"
        [tenantItems]="tenantItems"
        [requestContext]="requestContext()"
        [showLocationBadge]="isAdvancedSearchApplied()"
        (openFile)="openFile($event)"
        (doubleClickFile)="openFile($event)"
      />
    }

    @if (selectedTab === 'folders' && foldersFilters) {
      <app-folders-list
        [filters]="foldersFilters"
        [tenantItems]="tenantItems"
        [requestContext]="requestContext()"
        (openFolder)="openFolder($event)"
        (openFile)="openFileInModal($event)"
        (doubleClickFolder)="openFolder($event)"
      />
    }
  </div>
</div>

<ng-template #searchPopover>
  <app-files-search-popover [width]="600" (onSearch)="handleSearch()" (onCancel)="handleCancel()" />
</ng-template>
